import { Maybe, PaymentLimits, TokenBalance } from '../../../../../../graphql/generated/graphql'
import { isProduction } from '../../../../../app/config'
import { DirectPayType } from '../../context/DirectPayContext'
import { formatCurrency } from '../../../../../../utils/format'

export const directPaymentValidation = (
    type: DirectPayType,
    selectedToken: Maybe<TokenBalance>,
    limits: PaymentLimits | null
) => {
    const hasUSDBalance =
        selectedToken?.balanceUSD !== undefined && selectedToken?.balanceUSD !== null

    const paymentLimit = limits?.absolute ?? 0

    return {
        validate: {
            validAmount: (_amount: string) => {
                const amount = Number(_amount)
                if (amount <= 0) {
                    return 'Amount must be greater than zero'
                }
                if (amount < 1 && isProduction()) {
                    return 'Amount must be at least 1 dollar'
                }

                if (amount > 20000 && type === DirectPayType.OffRamp) {
                    return 'The max off-ramp limit is currently $20,000 per transaction'
                }

                if (amount >= 20000 && type === DirectPayType.BillPay) {
                    return "We only accept payments under $20,000. Please contact support if you'd like to make a larger payment."
                }

                if (paymentLimit && amount > paymentLimit) {
                    return `Current maximum payment for this account is ${formatCurrency(
                        paymentLimit
                    )}`
                }

                if (hasUSDBalance && amount > selectedToken.balanceUSD) {
                    return `There is only $${Math.floor(selectedToken.balanceUSD * 100) / 100} of ${
                        selectedToken.symbol
                    } available in this wallet.`
                }
            },
        },
    }
}
